
/*** Time countDOwn ***/
const timecountdown = document.querySelector('[data-timecountdown]');
  var sp_time;
  $(document).ready(function() {
    if(timecountdown){
      timecountdown.classList.remove('hidden');
      sp_time = setInterval(function(){
          showDays();
      }, 100);
    }
  });
function showDays(secondDate){
  
  var currentDateTime = new Date();
var options = {
  timeZone: "America/Los_Angeles",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  fractionalSecondDigits: 3,  // This adds milliseconds with 3 digits
  hour12: true
};

var formatter = new Intl.DateTimeFormat("en-US", options);
var formattedDate = formatter.format(currentDateTime);

// The formattedDate will look like "01/06/2025, 03:45:12.123 PM"
var [datePart, timePart] = formattedDate.split(", ");

// Split date part into month, day, and year
var [month, day, year] = datePart.split("/");

// Split time part into hour, minute, second, and milliseconds
var [time, ampm] = timePart.split(" ");
var [hour, minute, secondAndMillisecond] = time.split(":");
var [second, millisecond] = secondAndMillisecond.split(".");

// Convert hour to 24-hour format if it's in PM
if (ampm === "PM" && parseInt(hour) < 12) {
  hour = (parseInt(hour) + 12).toString(); // Convert PM hours to 24-hour format
} else if (ampm === "AM" && parseInt(hour) === 12) {
  hour = "00"; // Convert 12 AM to 00
}

// Construct the date in a format that JavaScript's `Date` object can parse
var formattedDateForJS = `${year}-${month}-${day}T${hour}:${minute}:${second}.${millisecond}`;

// Create a Date object from the formatted string
var startDay = new Date(formattedDateForJS).getTime();

console.log(startDay);

  
  const promoDate = (timecountdown.getAttribute('data-timecountdown')) ? timecountdown.getAttribute('data-timecountdown') : '11/30/2023 20:56:40';
  //var endDay = new Date(promoDate);

var endDayString = promoDate;

// Convert the time string to a 24-hour format
var [datePart, timePart] = endDayString.split(' ');
var [hour, minute] = timePart.split(':');
var [minutePart, ampm] = minute.split(' ');

// Adjust hour based on AM/PM
if (ampm === 'PM' && parseInt(hour) < 12) {
  hour = (parseInt(hour) + 12).toString(); // Convert PM hour to 24-hour
} else if (ampm === 'AM' && parseInt(hour) === 12) {
  hour = '00'; // Convert 12 AM to 00
}

// Create the final formatted string in ISO format
var formattedDate = `${datePart}T${hour}:${minutePart}:00`;

var endDay = new Date(formattedDate);


  
  var millisecondsPerDay = 1000 * 60 * 60 * 24;
  console.log(promoDate, formattedDate);
console.log(endDay, startDay);
  var millisBetween = endDay.getTime() - startDay;
  var tags = ["st-d", "st-h", "st-m", "st-s", "st-mi"];
  if(millisBetween < 0) {
	clearTimeout(sp_time);
	document.getElementById('st-d').innerHTML = '00';
	document.getElementById('st-h').innerHTML = '00';
	document.getElementById('st-m').innerHTML = '00';
	document.getElementById('st-s').innerHTML = '00';
	document.getElementById('st-mi').innerHTML = '000';	
	return;
  }
  var days = millisBetween / millisecondsPerDay;  
  var d_days = Math.floor(days);
  
  var r_hours = millisBetween -d_days * millisecondsPerDay;
  var d_hours = Math.floor(r_hours / (1000*60*60));
  
  var r_mins = r_hours - d_hours * (1000*60*60);
  var d_mins = Math.floor(r_mins / (1000*60));
  
  var r_sec = r_mins - d_mins * (1000*60);
  var d_sec = Math.floor(r_sec / 1000);
  var r_millie = r_sec - d_sec * 1000;
  
  var corr = [pad(d_days), pad(d_hours), pad(d_mins), pad(d_sec), pad2(r_millie)];
  for (var i = 0; i < tags.length; i++) {
	document.getElementById(tags[i]).innerHTML = corr[i];

  }
}
function pad(number) {
  if (number < 10) {
	return '0' + number;
  }
  return number;
}
function pad2(number) {
  if (number < 100) {
	if (number < 10)
		return '00' + number;
	else
		return '0' + number;
  }
  return number;
}
  